import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

@Component({
	selector: 'app-microsoft-callback',
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="callback-container">
			<div class="loading-wrapper">
				<div class="spinner-border text-primary" role="status">
					<span class="visually-hidden">Caricamento...</span>
				</div>
				<p>Autenticazione in corso, attendere...</p>
			</div>
		</div>
	`,
})
export class MicrosoftCallbackComponent implements OnInit {
	private route = inject(ActivatedRoute);
	private router = inject(Router);
	private authService = inject(AuthService);

	ngOnInit() {
		if (Capacitor.isNativePlatform()) {
			Browser.close().catch(() => {});
		}
		this.route.queryParams.subscribe((params) => {
			const code = params['code'];
			if (code) {
				this.completeLogin(code);
			} else {
				this.handleError('Codice di autenticazione mancante.');
			}
		});
	}

	completeLogin(code: string) {
		this.authService.loginMicrosoftComplete(code).subscribe({
			next: () => {
				const isNative = Capacitor.isNativePlatform();
				if (isNative) {
					this.router.navigate(['/app/dashboard']);
				} else {
					this.router.navigate(['/web/private']);
				}
			},
			error: (err) => {
				console.error('Errore durante il completamento del login Microsoft:', err);
				this.handleError("Errore durante l'autenticazione Microsoft. Riprova.");
			},
		});
	}

	handleError(message: string) {
		const isNative = Capacitor.isNativePlatform();
		const loginPath = isNative ? '/app/public/login' : '/web/public/login';
		// Potremmo usare un servizio di notifica qui, per ora usiamo l'area di errore del login se possibile
		// o semplicemente torniamo al login.
		this.router.navigate([loginPath], { queryParams: { error: message } });
	}
}
